import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ReplaySubject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PAGE_NAMES, ROLES, ROLES_TYPE } from '../../../core/helpers/constants';
import { getRolesForPage } from '../../../core/helpers/utility';
import { IPermission } from '../../../core/models/auth.models';
import { AppService } from '../../../store/app.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-reports-main',
  templateUrl: './reports-main.component.html',
  styleUrls: ['./reports-main.component.scss']
})
export class ReportsMainComponent implements OnInit {
  doWhat: IPermission = {} as IPermission;

  roleOptions: any = {};
  isAdmin: boolean = false;
  public userRoles: Array<any> = [];
  isExternal: boolean = false;
  hasRollupReportsAccess = false;
  hasBrandDashboardAccess = false;

  private rollupReportsRoles: Array<any>
    = [ROLES.Admin, ROLES.DMS, ROLES.TechServices, ROLES.ShopManager, ROLES.SalesRep, ROLES.Staff, ROLES.CompanyOwner, ROLES.MarketingManager, ROLES.ClientOwner];

  private brandDashboardRoles: Array<any>
    = [ROLES.Admin, ROLES.DMS, ROLES.TechServices, ROLES.ShopManager, ROLES.SalesRep, ROLES.Staff, ROLES.CompanyOwner, ROLES.MarketingManager];

  active: any = "";
  tabs = ['campaign-report', 'rollup-report', 'weekly-reports', 'brand-report'];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(private appService: AppService, private location: Location, private activatedRoute: Router,) {
    this.userRoles = this.appService.getActiveUserRoles$().value
  }

  private syncActiveTab(url: string): void {
    const normalizedUrl = (url || '').toLowerCase();

    if (normalizedUrl.includes('/reports/rollup-campaigns/') || normalizedUrl.includes('/reports/rollup-report/viewer/') || normalizedUrl.includes('/reports/rollup-report')) {
      this.active = 2;
      return;
    }

    if (normalizedUrl.includes('/reports/weekly-reports')) {
      this.active = 3;
      return;
    }

    if (normalizedUrl.includes('/reports/brand-report')) {
      this.active = 4;
      return;
    }

    if (normalizedUrl.includes('/reports/view-report/') || normalizedUrl.includes('/reports/raw-campaigns-data') || normalizedUrl.includes('/reports/campaign-report')) {
      this.active = 1;
      return;
    }

    this.active = 1;
  }

  ngOnInit(): void {
    this.appService.setPageTitle$('REPORTS');
    this.appService.getActiveUser$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(u => {
        this.isExternal = u.type == ROLES_TYPE.External
        var r = getRolesForPage(u.roles, PAGE_NAMES.Reports);
        this.isAdmin = r.isAdmin;
        if (r.options)
          this.roleOptions = JSON.parse(r.options!);
      });

    this.syncActiveTab(this.activatedRoute.url);

    this.activatedRoute.events
      .pipe(
        takeUntil(this.destroyed$),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        this.syncActiveTab(event.urlAfterRedirects);
      });

    this.hasRollupReportsAccess = this.userRoles.some(r => this.rollupReportsRoles.some(w => w.Code == r.code)); 
    this.hasBrandDashboardAccess = this.userRoles.some(r => this.brandDashboardRoles.some(w => w.Code == r.code)); 
  }


  onTabChange(event: number) {
    // console.log(event);
    const tabIndex = event - 1;
    this.location.go('/pages/reports/' + this.tabs[tabIndex]);
  }

  selectTab(tab: string, index: number) {
    this.active = index;
    this.navigateTo(tab);
  }

  navigateTo(tab: string) {
    this.activatedRoute.navigate(['/pages/reports', tab]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}